module.exports = __webpack_public_path__ + "static/media/pellet_power.8b1efc8e.png";